import { cacheDatabase } from "@/api/firebase/firebase.config";
import { getAuthorProfileBasedOnUid } from "@/api/search/searchUsernameByName";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEffect, useState } from "react";
import { useLeaderboardStore } from "@/store/leaderboard/leaderboard.store";

export const useLeaderboardData = ({
  filterKey,
  slug,
  client,
  selectedFilterType,
  status,
  inViewOfAll,
}) => {
  const databaseRef = cacheDatabase.ref("leaderboard");
  const [loading, setLoading] = useState<boolean>(false);
  const currentUser = useCurrentUserProfile((s) => s.user);
  const setNewLeaderboardStore = useLeaderboardStore((s) => s.addLeaderboard);
  const leaderboardStore = useLeaderboardStore((s) =>
    s.getLeaderboardByKey(slug)
  );

  const [leaderboardLiveData, setLeaderboardLiveData] = useState<any[]>(
    leaderboardStore || []
  );

  const [currentUserDataInThisChallenge, setCurrentUserDataInThisChallenge] =
    useState<any>({});

  // Live leaderboard for all
  const fetchLiveLeaderboard = async () => {
    setLoading(true);
    databaseRef
      .child(slug)
      .orderByKey()
      .limitToFirst(10)
      .on("value", async (snapshot) => {
        if (snapshot.val()?.leaderboard) {
          const newLeaderboardDataArray: any[] = [];

          await Promise.all(
            snapshot
              .val()
              .leaderboard.filter((element) => {
                return element?.userId && Object.keys(element).length !== 0;
              })
              .map(async (val: any) => {
                let author;

                if (val?.userId === currentUser?.uid) {
                  setCurrentUserDataInThisChallenge({
                    profile: currentUser,
                    userChallengeData: val.userChallengeData,
                  });

                  return newLeaderboardDataArray.push({
                    profile: currentUser,
                    userChallengeData: val.userChallengeData,
                  });
                }

                if (val && val.userId) {
                  const authorProfile = await getAuthorProfileBasedOnUid(
                    val.userId,
                    brand.tenantId
                  );

                  if (authorProfile) {
                    author = authorProfile;
                  } else {
                    if (client) {
                      const authorProfile2 = await getAuthorProfileBasedOnUid(
                        val.userId,
                        client
                      );

                      if (authorProfile2) {
                        author = authorProfile2;
                      }
                    }

                    if (!author) {
                      const authorProfile3 = await getAuthorProfileBasedOnUid(
                        val.userId,
                        brand.tenantId
                      );
                      if (authorProfile3) {
                        author = authorProfile3;
                      }
                    }
                  }

                  if (author) {
                    newLeaderboardDataArray.push({
                      profile: author,
                      userChallengeData: val.userChallengeData,
                    });
                  } else if (!author && val.userChallengeData) {
                    newLeaderboardDataArray.push({
                      profile: {
                        fullName: "",
                        slug: "",
                        uid: "",
                        userName: "Failed to load user's info",
                      },
                      userChallengeData: val.userChallengeData,
                    });
                  }
                }
              })
          );

          const sortedData = newLeaderboardDataArray.sort(
            (a, b) => a?.userChallengeData?.rank - b?.userChallengeData?.rank
          );

          setNewLeaderboardStore(slug, sortedData as any);
          setLeaderboardLiveData(sortedData);
        }
      });

    setLoading(false);
    if (status !== "ongoing") {
      databaseRef.off();
    }

    return;
  };

  useEffect(() => {
    if (status !== "ongoing") {
      databaseRef.off();
    }
  }, [status]);

  useEffect(() => {
    if (selectedFilterType === "ALL") {
      fetchLiveLeaderboard();
    }
  }, [inViewOfAll]);

  useEffect(() => {
    if (leaderboardLiveData && leaderboardLiveData.length !== 0 && !loading) {
      const userDoc = leaderboardLiveData.find(
        (doc) => doc.userId === currentUser.uid
      );

      if (userDoc) {
        setCurrentUserDataInThisChallenge({
          profile: currentUser,
          userChallengeData: userDoc,
        });
      }
    }
  }, [leaderboardLiveData]);

  return {
    leaderboardLiveData,
    currentUserDataInThisChallenge,
    loading,
    fetchLiveLeaderboard,
  } as const;
};
